import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=54e84ded&scoped=true&"
import script from "./Cookies.js?vue&type=script&lang=js&"
export * from "./Cookies.js?vue&type=script&lang=js&"
import style0 from "./Cookies.scss?vue&type=style&index=0&id=54e84ded&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e84ded",
  null
  
)

export default component.exports